import type { FC } from "react";

import TrackProvider from "../../../components/WithTrack/src/TrackProvider";
import TranslationProvider from "../../../components/WithTranslation/src/TranslationProvider";

export const AllContexts: FC<any> = ({ translate, track, children }) => (
    <TranslationProvider translate={translate}>
        <TrackProvider track={track}>{children}</TrackProvider>
    </TranslationProvider>
);
